<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 점검정보 -->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 기본정보</h5>
      </vs-col>
    </vs-row>

    <div class="grid xl:grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">담당부서</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
        <company-selector v-else v-model="form.inputA_0" :company-name="form.inputA_1" @select="targetCompany" :readonly="board.readonly" class="w-full flex-1" />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검자명</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_2 }}</p>
        <ml-input v-else v-model="form.inputA_2" class="w-full flex-1" />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검일</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
        <date-selector v-else :readonly="board.readonly" placeholder="날짜선택" class="w-full flex-1" v-model="form.inputA_3" />
      </div>
    </div>

    <!-- 구분 -->
    <div class="mb-8">
      <vs-row class="my-4">
        <vs-col class="flex items-center">
          <h5><i class="dot"></i>구분</h5>
        </vs-col>
      </vs-row>
      <vs-row class="grid grid-cols-12">
        <vs-col class="col-span-2">
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div v-if="form.inputA_4 === '상반기'" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">상반기</span>
          </div>
          <div v-else>
            <span class="flex"><vs-checkbox v-model="form.inputA_4" vs-value="상반기" /> 상반기</span>
          </div>
        </vs-col>
        <vs-col>
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div v-if="form.inputA_4 === '하반기'" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">하반기</span>
          </div>
          <div v-else>
            <span class="flex"><vs-checkbox v-model="form.inputA_4" vs-value="하반기" /> 하반기</span>
          </div>
        </vs-col>
      </vs-row>
    </div>

    <!-- 업무 수행 여부 -->
    <div>
      <vs-row class="my-4">
        <vs-col class="flex items-center">
          <h5><i class="dot"></i>업무 수행 여부</h5>
          <div class="flex items-center cursor-pointer" @click="openPopup">
            <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />
            <span style="color: #7e72f2"> 이행사항 점검 시 작성요령 </span>
          </div>
        </vs-col>
      </vs-row>
      <table-inspect
        class="mt-5"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="false"
        :is-note="true"
        table-header-yes="양호"
        table-header-normal="보통"
        table-header-no="미흡"
        table-header-na="해당없음"
        table-header-note="개선요망 사항 및 비고"
        footer="※ (시행령=중대재해처벌 등에 관한 법률. 산안법=산업안전보건법)"
        v-model="form.inspectList"
      />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />

    <!-- 이행사항 점검 시 작성요령 팝업 -->
    <vs-popup id="popAlert" title="이행사항 점검 시 작성요령" :active.sync="showPopup">
      <table id="PopupTable" style="margin-bottom: 20px">
        <tr>
          <th>증빙자료 첨부</th>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2 font-bold">점검결과 판단기준(연번 1~8번)</b>
            <ul>
              <li class="mb-1">1. 양호 : 완료된 경우</li>
              <li class="mb-1">2. 보통 : 계획을 수립하였으나, 이행하지 않은 경우 / 이행 중인 경우</li>
              <li class="mb-1">3. 미흡 : 계획 미수립 및 이행하지 않은 경우(반기별 의무이행 사항 불이행)</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="p-3 font-bold">반드시 디지털 안전보건 시스템(마엇)에 증빙자료 업로드 (업로드 매뉴얼 참고)</td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2">작성요령</b>
            <ul class="tab-ul">
              <li class="mb-1">
                <p>연번 1 :</p>
                <p>시스템 ‘인력’목록에 계획서상 안전인력 업로드 및 추가 인력 입력(관리부서, 수탁업체 인력 모두 입력 필수)</p>
              </li>
              <li class="mb-1">
                <p>연번 2 :</p>
                <p>시스템 ‘예산’목록-1월 페이지에 계획서상 안전보건 예산 업로드</p>
              </li>
              <li class="mb-1">
                <p>연번 3 :</p>
                <p>
                  반기별 정기 안전점검 계획-이행-보수조치 결과서 업로드 / 개별법령상 기타 법정 안전점검 이행여부<br />
                  <span style="color: #0029ff; text-decoration: underline">※ 시특법상 제1종, 2종, 3종 시설물은 기타 법정 안전점검(정밀안전점검 및 진단 등) 해당 여부 필수 확인</span><br />
                  <span style="color: #ff0000; text-decoration: underline">제출한 안전보건관리계획에 해당 점검계획이 모두 포함되어 있어야 하며, 계획에 따라 이행되고 있어야 함</span>
                </p>
              </li>
              <li class="mb-1">
                <p>연번 4 :</p>
                <p>시스템 ‘관리부서 안전계획’목록에 기제출한 안전보건관리계획 업로드 확인</p>
              </li>
              <li class="mb-1">
                <p>연번 5 :</p>
                <p>
                  (1) - ‘계획 수립’은 안전보건관리계획에 포함하여 기제출 했으므로 ‘양호’에 체크<br />
                  - ‘이행’은 제출한 안전보건관리<span style="color: #0029ff; text-decoration: underline">계획에 상반기에 하기로 한 유해위험요인 점검이 있을 시에만</span> 증빙자료 업로드<br />
                  (2) 안전보건관리계획에 포함하여 기제출 했으므로 ‘양호’에 체크<br />
                  (3) 안전보건관리계획에 포함하여 기제출 했으므로 ‘양호’에 체크<br />
                  (4) 안전보건관리계획에 포함하여 기제출 했으므로 ‘양호’에 체크<br />
                </p>
              </li>
              <li class="mb-1">
                <p>연번 6 :</p>
                <p>
                  (1) 도급용역위탁 시 평가기준 및 절차 마련<br />
                  (2) 연1회 담당자가 직접 평가기준에 따라 수탁기관을 점검해야 함. 하반기에 이행할 경우 ‘보통’에 체크
                </p>
              </li>
              <li class="mb-1">
                <p>연번 7 :</p>
                <p>
                  안전보건 관계 법령이란 시설물에 적용되는 모든 개별법령을 의미함(건축법, 재난안전법, 시특법, 도서관법 등)<br />
                  ※ 시설 담당자는 해당하는 개별법령을 확인하여 의무이행 여부를 자체적으로 점검하여야 함
                </p>
              </li>
              <li class="mb-1">
                <p>연번 8 :</p>
                <p>
                  (1) 시스템 ‘교육’목록에 계획서상 안전보건 교육자 명단 업로드 및 상반기 이수자 교육 이수증 업로드<br />
                  (2) 미이수 사항 발견시 개선조치 계획 제출
                </p>
              </li>
            </ul>
          </td>
        </tr>
        <!--        연번 1  : 사업장을 담당하는 관리부서 담당자의 업무사항이 나와있는 자료(업무사항에 반드시 에 대한 내용이 명시되어 있어야 함</span>. 업무분장표를 제출할 경우, 하이라이트 등을 이용하여 담당자 명시 필수)-->
        <!--        <tr>-->
        <!--          <td style="text-align: center; font-size: 14px; line-height: 24px; color: #0029ff;font-weight: 700;padding: 14px;">-->
        <!--            * 필독!!<br/>-->
        <!--            자체점검 결과가 ‘보통’인 사항은 비고란에 <span style="color: #e42728; text-decoration: underline;">미이행사항 및 개선 조치 계획</span> 등을 기재,<br/>-->
        <!--            ‘미흡’인 사항에 대해서는 <span style="color: #e42728; text-decoration: underline;">미이행사항 및 개선 조치 계획</span>보완 조치 계획, 재점검 계획 등을 별도로 첨부</span>하여 제출-->
        <!--          </td>-->
        <!--        </tr>-->
      </table>
    </vs-popup>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspectNo";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],
        inspectList: [
          {
            label: "필요한 안전인력 확보 [시행령 제10조제1호]",
            chlid: [
              {
                label: "시설·설비 안전보건 조치 업무 담당",
                is_checked: "",
              },
              {
                label: "시설·설비 유지보수 업무 관리",
                is_checked: "",
              },
            ],
          },
          {
            label: "필요한 안전예산 편성·집행 [시행령 제10조제2호]",
            chlid: [
              {
                label: "안전보건 관련 인건비",
                is_checked: "",
              },
              {
                label: "시설·설비 안전 확보 유지관리비",
                is_checked: "",
              },
              {
                label: "안전점검비",
                is_checked: "",
              },
              {
                label: "기타비용(보수·보강비 등)",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전점검 계획 수립 및 시행 [시행령 제10조제3호]",
            chlid: [
              {
                label: "정기안전점검 계획 수립",
                is_checked: "",
              },
              {
                label: "정기안전점검 계획 이행",
                is_checked: "",
              },
              {
                label: "정밀안전진단, 정밀 안전진단 이행",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전계획 수립 및 이행 [시행령 제10조제4호]",
            chlid: [
              {
                label: "인력 및 예산에 관한 사항",
                is_checked: "",
              },
              {
                label: "안전점검 또는 정밀안전진단의 실시에 관한 사항",
                is_checked: "",
              },
              {
                label: "보수·보강 등 유지관리에 관한 사항",
                is_checked: "",
              },
            ],
          },
          {
            label: "재해예방 업무처리 절차 마련·이행 [시행령 제10조제7호]",
            chlid: [
              {
                label: "유해·위험요인 점검 계획 수립 및 이행",
                is_checked: "",
              },
              {
                label: "유해·위험요인 발견 시 조치 및 개선 절차 마련",
                is_checked: "",
              },
              {
                label: "재해 발생 시 대응 절차 및 매뉴얼 마련",
                is_checked: "",
              },
              {
                label: "비상대피훈련 계획 등(시특법 상 제1종 시설물)",
                is_checked: "",
              },
            ],
          },
          {
            label: "도급·용역·위탁 기준과 절차 마련·이행 [시행령 제10조제8호]",
            chlid: [
              {
                label: "도급·용역·위탁 시 평가기준 및 절차 마련",
                is_checked: "",
              },
              {
                label: "도급·용역·위탁 평가기준에 따라 수탁기관 점검",
                is_checked: "",
              },
            ],
          },
          {
            label: "기타 안전보건 관계 법령(시설물에 적용되는 개별 법령) 의무이행 점검 [시행령 제11조제2항제1호, 2호]",
            chlid: [
              {
                label: "의무이행사항 점검",
                is_checked: "",
              },
              {
                label: "미이행 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
          {
            label: "시설 안전관리자/종사자 의무교육 이행 점검 [시행령 제11조제2항제3호, 4호]",
            chlid: [
              {
                label: "교육 이수 대상 확정 및 이수 점검",
                is_checked: "",
              },
              {
                label: "미이수 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
        ],
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: [],
      },
    };
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    targetCompany(value) {
      this.form.inputA_1 = value.com_name;
    },
  },
};
</script>

<style scoped lang="scss">
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  ul.tab-ul li {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;

    p:first-child {
      width: 52px;
    }
    p:last-child {
      flex: 1;
    }
  }
  li {
    margin-left: 16px;
    &::marker {
      content: " · ";
      font-size: 1.2em;
    }
  }
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
  word-break: keep-all;
}
</style>
